import * as React from "react";
import { styles } from "./Background.style";
import { withStyles } from "@material-ui/core";

const Background = (props) => {    
    return (
        <div className={props.classes.container}>
            {props.children} 
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(Background);



// WEBPACK FOOTER //
// ./src/components/Background/Background.tsx